module.exports = __webpack_public_path__ + "static/media/4.question.b2480e85.mp4";